import api from 'Application/api/api';

const hideTemplateQuestion = (
    templateId,
    questionId,
    isCustom,
    cancelToken = null,
) =>
    api.post(
        `project-manager/templates/${templateId}/questionnaire/questions/${questionId}/${
            isCustom ? 1 : 0
        }/hide`,
        {},
        { cancelToken },
    );

export default hideTemplateQuestion;
